import {GRANITE_2} from '@gaia/colors';
import Button from '@gaia/components/Button';
import {HeaderLogin} from '@gaia/components/header-ui/HeaderLogin';
import {HeaderNotifications} from '@gaia/components/header-ui/HeaderNotifications';
import {HeaderSignup} from '@gaia/components/header-ui/HeaderSignup';
import {HeaderUser} from '@gaia/components/header-ui/HeaderUser';
import {useUser} from '@gaia/stores/user';
import theme from '@gaia/theme';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import AuthModalContext from '@map/contexts/AuthModalContext';
import FloatingCard from '@map/FloatingCard';
import classes from '@map/Map/Map.module.css';
import {useGoPremiumModalToggle} from '@map/popups/GoPremiumModal';
import {useCallback, useContext} from 'react';

export function MapHeader() {
    const {isAuthenticated} = useUser();
    const setAuthModal = useContext(AuthModalContext);

    return (
        <div className={classes.header}>
            <HeaderNotifications.Toolbar style={{color: GRANITE_2}} />
            {isAuthenticated ? (
                <>
                    <CTAButton />
                    <HeaderUser.Toolbar isFloating={true} style={{color: GRANITE_2}} />
                </>
            ) : (
                <FloatingCard>
                    <div>
                        <HeaderLogin.Toolbar
                            setAuthModalState={setAuthModal}
                            style={{
                                marginRight: theme.spacing(1),
                            }}
                        />
                        <HeaderSignup.Toolbar
                            setAuthModalState={setAuthModal}
                            style={{marginRight: theme.spacing(1)}}
                        />
                        <CTAButton />
                    </div>
                </FloatingCard>
            )}
        </div>
    );
}

function CTAButton() {
    const {hasPremiumSubscription} = useUser();

    const shouldNotRender = hasPremiumSubscription;

    const toggleGoPremiumModal = useGoPremiumModalToggle();

    const handleClick = useCallback(() => {
        ampli.clickGoPremiumUpsellButton();
        toggleGoPremiumModal();
    }, [toggleGoPremiumModal /* stable */]);

    return shouldNotRender ? null : (
        <Button appearance='primary' onClick={handleClick}>
            Go Premium
        </Button>
    );
}
